import { FEED_FILTER_TEAMS, FEED_FILTER } from 'app/constants/feed'

export const parseTeamsBeforeAddToSelect = teams => teams.map(teamName => ({ name: teamName, value: teamName }))

export const parseTeamsBeforeShow = teams => {
  switch (teams.length) {
    case 0:
      return
    case 1:
      return `${teams[0]}`
    case 2:
      return `${teams[0]}, ${teams[1]}`
    default:
      return `${teams[0]}, ${teams[1]}, ...`
  }
}

export const parseTeamsBeforeSend = teams => teams.map(teamObject => teamObject.value)

export const normalizeTeams = (values, prevValues) => {
  // when super-admin will remove all the teams from list - values will be passed as null
  if (values === null) return []
  const teamsNamesLikeSpaces = values.filter(val => {
    return !val.value.replace(/\s+/g, '')
  })
  // check if value exists only spaces
  if (teamsNamesLikeSpaces.length) {
    return prevValues
  }
  return values
}

export const getTeamFilterOptions = (isTeamOnly, teams) => {
  const options = parseTeamsBeforeAddToSelect(teams.toJS())

  if ((isTeamOnly && teams.size > 1) || (!isTeamOnly && teams.size >= 1)) {
    return [
      {
        name: 'All teams',
        value: isTeamOnly ? FEED_FILTER_TEAMS : FEED_FILTER,
      },
    ].concat(options)
  }

  return options
}
